// import { dispatcher } from 'js/dispatcher';
import subCategoryStore from '../stores/store';
const dispatch = subCategoryStore.dispatch;

const subCategoryActions = {
  updateSubcatView(v) {
    dispatch({
      type: 'UDPATE_SUBCAT_VIEW',
      payload: v
    });
  },

  updateSymbologyJson(j) {
    dispatch({
      type: 'UPDATE_SYMBOLOGY_JSON',
      payload: j
    });
  },

  updateCount(num) {
    dispatch({
      type: 'UPDATE_COUNT',
      payload: num
    });
  },

  updateMyIcons(iconObj) {
    dispatch({
      type: 'UPDATE_MY_ICONS',
      payload: iconObj
    });
  },

  updateCurrentIcon(icon) {
    dispatch({
      type: 'UPDATE_CURRENT_ICON',
      payload: icon
    });
  },

  updateFilteredPacks(packs) {
    dispatch({
      type: 'UPDATE_FILTERED_PACKS',
      payload: packs
    });
  },

  updateBreadCrumbs(bc) {
    dispatch({
      type: 'UPDATE_BREAD_CRUMBS',
      payload: bc
    });
  },

  appendToBreadCrumbs(obj) {
    dispatch({
      type: 'APPEND_TO_BREAD_CRUMBS',
      payload: obj
    });
  },

  removeFromBreadCrumbs(i) {
    dispatch({
      type: 'REMOVE_FROM_BREAD_CRUMBS',
      payload: i
    });
  }
};

export default subCategoryActions;



// WEBPACK FOOTER //
// ./src/js/actions/actions.js